import React, { Component } from 'react';
import axios from 'axios';
import _ from 'lodash';
import { API_URL } from '../../partials/Globals';
import Errors from '../../partials/Errors';
import StudentShares from './StudentShares';
import Lightbox from '../../partials/Lightbox';

export default class Shares extends Component {
    state = {
        errors: '',
        message: '',
        group: {
            name: '',
            students: {}
        },
        project: {
            id: '',
            title: ''
        },
        lightbox: false
    }

    constructor(props) {
        super(props);

        this.fetch = this.fetch.bind(this);
        this.toggleLightbox = this.toggleLightbox.bind(this);
    }

    componentDidMount() {
        this.fetch();
    }

    fetch() {
        axios.get(API_URL+'/admin/groups/'+this.props.match.params.group_id)
            .then(response => {
                this.setState({ group: response.data }, function() {
                    let projects = this.state.group.projects;
                    const project_id = parseInt(this.props.match.params.project_id, 10);
                    const project = _.find(projects, ['id', project_id]);
                    this.setState({ project });
                });
            });
    }


    toggleLightbox() {
        this.setState({ lightbox: (this.state.lightbox === true ? false: true) });
    }

    render() {
        const { project, group } = this.state;
        const self = this;

        return (
            <div>
                <Lightbox open={ this.state.lightbox } toggle={ this.toggleLightbox } contents={ <div><h3>Fördela andelar</h3><p>Alla användare markerade med <strong>(ej kopplad)</strong> kan varken se eller sälja andelar för projektet. Genom att klicka på <strong>Spara</strong> ges användaren tillgång till projektet.</p><p>Ni måste inte fördela några andelar utan kan lämna fältet tomt eller sätta en nolla. Genom att sätta en siffra i fältet så ser användarna ett tydligare mål om hur många andelar de ska sälja. De kan oavsett sälja hur många andelar de vill.</p></div> } />

                <div className="top">
                    <div className="col-12">
                        <button className="back" onClick={ this.props.history.goBack }>Tillbaka</button>
                        <button className="lightbox-toggle" onClick={ this.toggleLightbox }></button>
                    </div>
                </div>

                <Errors errors={ this.state.errors } />
                
                <div className="container">
                    <div className="content">
                        <h1>Fördela andelar att sälja för projektet { this.state.project.title } till { this.state.group.name }</h1>

                        <div className="block">
                            <div className="header">
                                <h4>Deltagare</h4>
                            </div>

                            <div className="body">
                                { (group.students.length > 0 && project.id) &&
                                    <ul>
                                        { Object.keys(group.students).map(function(key) {
                                            return <StudentShares key={ key } student={ group.students[key] } group_id={ group.id } project_id={ project.id } update={ self.fetch } />
                                        }) }
                                    </ul>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/admin/Group/Shares.js